import { PracticeProfile, ProfileKeyword, SpecialistProfile, Statistic } from '../types'
import { mergeStatisticByName } from './statistic'
import { AMOUNT_KEYWORDS } from '../constants/search'

export type GetTreatmentsProps = {
  specialist?: SpecialistProfile
  practice?: PracticeProfile
  mergedStatistic: Statistic[]
  reviewStatistic: Statistic[]
  language: string
  specialty: ProfileKeyword
  selectedKeyword: string
}

export const getTreatments = ({
  specialist,
  practice,
  mergedStatistic,
  reviewStatistic,
  language,
  specialty,
  selectedKeyword
}: GetTreatmentsProps) => {
  const mergedStatisticByName = specialist
    ? mergedStatistic.reduce(mergeStatisticByName(language), [])
    : reviewStatistic.reduce(mergeStatisticByName(language), [])
  const altRelatedKeyword = (specialist || practice)?.statistic.find(
    (statisticItem) => statisticItem.tagId === specialty.id
  )

  return [
    ...(specialty?.name?.[language] && specialty.id !== 1
      ? [
          {
            label: specialty.name[language],
            variant: 'primary',
            count: altRelatedKeyword?.tagKeyword !== 'specialty' ? altRelatedKeyword?.tagCount : 0
          }
        ]
      : []),
    ...mergedStatisticByName
      .filter((keyword) => keyword.tagName[language] !== selectedKeyword && keyword.tagId !== specialty.id)
      .map((item) => ({ label: item.tagName[language], variant: 'secondary' }))
  ].slice(0, AMOUNT_KEYWORDS)
}
